import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import LicenseAgreement from '../../components/signup/LicenseAgreement';
import { startTrial, cancelAgreement } from '../../actions/signup';

import { Mixpanel } from '../../lib/Mixpanel';

const mapStateToProps = state => ({
  processing: state.signup.license.submitting,
  error: state.signup.license.error,
});

const mapDispatchToProps = dispatch => ({
  handleAgree: history => {
    Mixpanel.track('Trial / EULA-Agree', {});
    dispatch(startTrial(history));
  },
  clearInfo: () => {
    dispatch(cancelAgreement());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LicenseAgreement));
